<div #scrollableContent class="field-dialog__content__scroll p-24" fxLayout="column" fusePerfectScrollbar>
  <div *ngIf="equipmentMaintenancesMapped.length">
    <ng-container *ngFor="let equipmentMaintenance of equipmentMaintenancesMapped; index as index">
      <div class="maintenance">
        <div class="maintenance-icon-wrapper">
          <div class="maintenance-icon {{ equipmentMaintenance.colorClass }}-bg">
            <i class="angularjs-fuse-icon" [ngClass]="equipmentMaintenance.icon"></i>
          </div>
          <span class="maintenance-line"></span>
        </div>

        <div class="card mb-0">
          <div class="card__item mt-0">
            <div class="maintenance-title">
              <div class="maintenance-title__description">
                <span
                  class="{{ equipmentMaintenance.colorClass }}-text"
                  [innerHTML]="equipmentMaintenance.eventName"
                ></span>
              </div>
              <div class="maintenance-title__date font-color-gray">
                {{ equipmentMaintenance.createdAt }}
              </div>
            </div>
            <div *ngIf="equipmentMaintenance.customAuthor" class="maintenance-author-and-device font-color-gray">
              <mat-icon inline>{{ equipmentMaintenance.customAuthorDevice || 'laptop' }}</mat-icon>
              <span>{{ equipmentMaintenance.customAuthor }}.</span>
            </div>

            <div class="font-color-gray mt-10">
              <p
                class="maintenance-description"
                *ngIf="equipmentMaintenance.eventDescription && equipmentMaintenance.eventDescription.location"
                [innerHTML]="equipmentMaintenance.eventDescription.location"
              ></p>
              <p
                class="maintenance-description"
                *ngIf="equipmentMaintenance.eventDescription && equipmentMaintenance.eventDescription.segment"
                [innerHTML]="equipmentMaintenance.eventDescription.segment"
              ></p>
              <p
                class="maintenance-description"
                *ngIf="equipmentMaintenance.eventDescription && equipmentMaintenance.eventDescription.maintenanceType"
                [innerHTML]="equipmentMaintenance.eventDescription.maintenanceType"
              ></p>
              <p
                class="maintenance-description"
                *ngIf="equipmentMaintenance.eventDescription && equipmentMaintenance.eventDescription.company"
                [innerHTML]="equipmentMaintenance.eventDescription.company"
              ></p>
            </div>
            <button
              class="view-maintenance-button"
              mat-button
              (click)="openEquipmentMaintenanceDialog(equipmentMaintenance.id)"
            >
              {{ 'EQUIPMENTS.DIALOG.HISTORIC_MAINTENANCES.VIEW_MAINTENANCE' | translate }}
            </button>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
  <div *ngIf="!equipmentMaintenancesMapped.length" fxLayout="column" fxLayoutAlign="center center" class="p-24">
    <p fxFlex="100" fxLayout="row" fxLayoutAlign="center center">
      <mat-icon class="no-results-icon">history</mat-icon>
    </p>
    <span class="h3">
      {{ 'EQUIPMENTS.DIALOG.HISTORIC_MAINTENANCES.NO_HISTORIC' | translate }}
    </span>
  </div>
  <div *ngIf="loading" fxLayout="column" fxLayoutAlign="center center" class="p-24">
    <mat-spinner [diameter]="32"></mat-spinner>
  </div>
</div>
